// Vendor imports
const Immutable = require('immutable')
// Client V2 common imports
const {
  keyedReviver,
  listReviver
} = require('client-v2/common/state/revivers')

class LightweightEngagementTutorialSlideRecord extends Immutable.Record({
  messageHtml: String(),
  messageText: String(),
  posterUrl: String(),
  videoUrl: String()
}) {
  // No methods
}

LightweightEngagementTutorialSlideRecord.reviver = keyedReviver(LightweightEngagementTutorialSlideRecord, {
  // No nested data structures
})

class LightweightEngagementTutorialRecord extends Immutable.Record({
  isVisible: Boolean(),
  slides: Immutable.List()
}) {
  // No methods
}

LightweightEngagementTutorialRecord.reviver = keyedReviver(LightweightEngagementTutorialRecord, {
  slides: listReviver(LightweightEngagementTutorialSlideRecord.reviver)
})

module.exports = LightweightEngagementTutorialRecord
